import { HssDutyPeriod } from "./hss-duty-period";
import { HssHeader } from "./hss-header";
import { HssLeg } from "./hss-leg";
import { SequenceSummary } from "./sequence-summary";

export class Hss {
  timestamp = "";
  timestampHbt = "";
  sequenceUpdateId = 0;
  header: HssHeader;
  dutyPeriods: HssDutyPeriod[] = [];
  legs: HssLeg[] = [];
  summary = new SequenceSummary();
  isPilotChange = false;
  isRo = false;
  isAf = false;
  isCxl = false;

  constructor(position: string, sequenceUpdateId: number) {
    this.header = new HssHeader(position);
    this.sequenceUpdateId = sequenceUpdateId;
  }
}
